import { useState } from 'react'

import { Box, Button, NumberBadge, Text } from '@factorialco/deprecated-design-system'

import './index.styles.css'

export interface Tour {
  id: string
  title: string
  description: string
  helpCenterUrl: string
  buttonText: string
  onClick: () => void
  tourGroup: string
}

export interface TourItemProps {
  tour: Tour
}

export interface ToursListProps {
  title: string
  tours: Tour[]
  position: number
}

const TourItem: React.FC<TourItemProps> = ({ tour }) => (
  <Box flexDirection="row" alignItems="center" justifyContent="spaceBetween">
    <Box>
      <Text size="300" weight="medium" color="black">
        {tour.title}
      </Text>
      <Text size="300">{tour.description}</Text>
    </Box>
    <Box flexDirection="row" gap="s8">
      {tour.helpCenterUrl && (
        <Button
          type="secondary"
          iconName="external link"
          onClick={() => window.open(tour.helpCenterUrl)}
        />
      )}
      <Button type="primary" onClick={tour.onClick}>
        {tour.buttonText}
      </Button>
    </Box>
  </Box>
)

const ProductUpdatesToursList: React.FC<ToursListProps> = ({ title, tours, position }) => {
  const [isExpanded, setIsExpanded] = useState(position === 1)

  return (
    <Box
      padding="s12"
      gap="s8"
      border={{
        all: {
          width: 's1',
          style: 'solid',
          color: 'grey400',
        },
      }}
      borderRadius={{
        all: 'abs016',
      }}
    >
      <Box
        flexDirection="row"
        alignItems="center"
        justifyContent="spaceBetween"
        onClick={() => setIsExpanded(!isExpanded)}
        cursor="pointer"
        padding="s8"
        borderRadius={{
          all: 'abs008',
        }}
        className={'ProductUpdatesTourList_clickableHeader'}
      >
        <Box flexDirection="row" alignItems="center" gap="s8">
          <Box
            style={{
              transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
              transition: 'transform 0.2s ease-in-out',
            }}
          >
            <Text size="300" color={isExpanded ? 'grey800' : 'grey600'}>
              ►
            </Text>
          </Box>
          <NumberBadge label={position} color="radicalRed200" textColor="radicalRed1000" />
          <Text size="300" weight="medium" color="black">
            {title}
          </Text>
        </Box>
      </Box>
      {isExpanded && (
        <Box
          padding="s12"
          gap="s16"
          background="grey100"
          border={{
            all: {
              width: 's1',
              style: 'solid',
              color: 'grey400',
            },
          }}
          borderRadius={{
            all: 'abs016',
          }}
        >
          {tours.map((tour) => (
            <TourItem key={tour.id} tour={tour} />
          ))}
        </Box>
      )}
    </Box>
  )
}

export default ProductUpdatesToursList
